module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('h2', {
    staticClass: "ui center aligned icon header"
  }, [_c('i', {
    staticClass: "list icon"
  }), _vm._v("Todos\n    "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v(_vm._s(_vm.tasks.length) + " items")])]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid action input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask.title),
      expression: "newTask.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter a new task"
    },
    domProps: {
      "value": (_vm.newTask.title)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.add($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTask.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ui icon button",
    on: {
      "click": _vm.add
    }
  }, [_c('i', {
    staticClass: "plus icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ui list"
  }, _vm._l((_vm.tasks), function(task) {
    return _c('Item', {
      key: task._id,
      attrs: {
        "task": task
      },
      on: {
        "del": _vm.del
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6af9de39","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Todo.vue
// module id = 26
// module chunks = 0